export const sortByKey = (key) => (a, b) => a[key] - b[key];
export const sortByKeyDesc = (key) => (a, b) => b[key] - a[key];
export const sortByDate = (key) => (a, b) => new Date(a[key]) - new Date(b[key]);
